module.exports = __webpack_public_path__ + "static/img/dialitis.841251f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/dialitis.png
// module id = 449
// module chunks = 1